module.exports = __webpack_public_path__ + "static/media/pragmaticpeugeotm.e1159485.webp";